import { Grid } from '@material-ui/core';
import { Document } from '@roc/feature-types';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import BorrowerEntity from './borrowerEntity';
import BorrowerEntityWarnings from './borrowerEntityWarnings';
import EditBorrowerDialog from './editBorrowerDialog';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { WithDocumentActions } from '../../../utils/withDocumentActions';

export type BorrowerEntityDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loanId: any;
  document: Document;
};

export const BorrowerEntityDialog = observer(
  (props: BorrowerEntityDialogProps) => {
    const { open, onClose, loanId, document } = props;
    const { documentStore } = useDocumentStore();
    const { documentFormStore } = documentStore;
    const { borrowerEntityStore } = documentFormStore;
    const { reviewLogStore, globalStore } = borrowerEntityStore;
    const { isInternalPortal, isAttorneyPortal } = globalStore;
    const allowSubmit = isInternalPortal || isAttorneyPortal;
    const taskId = document?.taskId;

    const onSubmit = async () => {
      borrowerEntityStore.submit();
    };

    useEffect(() => {
      if (open) {
        borrowerEntityStore.initForm(document);
      }
    }, [open]);

    const getActions = () => {
      return (
        <Grid container spacing={1} justifyContent="flex-end">
          <Grid item>
            <Button
              onClick={() => {
                onClose();
                reviewLogStore.reset();
              }}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              {allowSubmit ? 'Cancel' : 'Close'}
            </Button>
          </Grid>
          <Grid item>
            <WithDocumentActions
              component={Button}
              document={document}
              onClick={onSubmit}
              color="primary"
              variant="contained"
              testId="confirm"
            >
              Submit
            </WithDocumentActions>
          </Grid>
        </Grid>
      );
    };

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            open={open}
            title="Borrower Entity"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={<BorrowerEntity store={borrowerEntityStore} />}
            dialogActions={getActions()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Borrower Entity"
            maxWidth="lg"
            handleClose={onClose}
            removeContentBox
            dialogContent={<BorrowerEntity store={borrowerEntityStore} />}
            dialogActions={getActions()}
          />
        )}

        <EditBorrowerDialog />
        <BorrowerEntityWarnings />
      </>
    );
  }
);

export default BorrowerEntityDialog;
